module.exports = __webpack_public_path__ + "img/keras.c309c4c6.png";